import React, { useEffect } from 'react';
import { __ } from '../../Lang.js';

const GuestTestimonials = () => {
  useEffect(() => {
    let slider = null;
    let slides = [];
    let currentSlide = 0;
    let autoSlideInterval = null;

    function showSlide(index) {
      slides.forEach((slide) => {
        slide.classList.remove('active', 'prev');
      });

      document.querySelectorAll('.testimonials__dot').forEach((dot) => {
        dot.classList.remove('active');
      });

      slides[index].classList.add('active');

      const currentSlideDots = slides[index].querySelectorAll('.testimonials__dot');
      if (currentSlideDots[index]) {
        currentSlideDots[index].classList.add('active');
      }

      currentSlide = index;
    }

    function nextSlide() {
      const next = (currentSlide + 1) % slides.length;
      showSlide(next);
    }

    function prevSlide() {
      const prev = (currentSlide - 1 + slides.length) % slides.length;
      showSlide(prev);
    }

    function startAutoSlide() {
      autoSlideInterval = setInterval(nextSlide, 5000);
    }

    function resetAutoSlide() {
      clearInterval(autoSlideInterval);
      startAutoSlide();
    }

    function initSlider() {
      slider = document.getElementById('testimonialSlider');
      if (!slider) return;

      slides = slider.querySelectorAll('.testimonials__slide');
      showSlide(0);
      startAutoSlide();

      document.querySelectorAll('.testimonials__dot').forEach((dot) => {
        dot.addEventListener('click', () => {
          const slideIndex = parseInt(dot.getAttribute('data-slide'));
          showSlide(slideIndex);
          resetAutoSlide();
        });
      });

      document.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowLeft') {
          prevSlide();
          resetAutoSlide();
        } else if (e.key === 'ArrowRight') {
          nextSlide();
          resetAutoSlide();
        }
      });

      let startX = 0;
      let endX = 0;

      slider.addEventListener('touchstart', (e) => {
        startX = e.touches[0].clientX;
      });

      slider.addEventListener('touchend', (e) => {
        endX = e.changedTouches[0].clientX;
        const difference = startX - endX;

        if (Math.abs(difference) > 50) {
          if (difference > 0) {
            nextSlide();
          } else {
            prevSlide();
          }
          resetAutoSlide();
        }
      });

      slider.addEventListener('mouseenter', () => {
        clearInterval(autoSlideInterval);
      });

      slider.addEventListener('mouseleave', () => {
        startAutoSlide();
      });
    }

    initSlider();
  }, []);

  return (
    <section className="section testimonials bg-light">
      <div className="testimonials__container">
        <div className="testimonials__slider" id="testimonialSlider">
          <div className="testimonials__slide active">
            <blockquote className="testimonials__quote">
              {__(
                'Thank you, thank you, thank you. You have created and continue to create an incredible gift to all with eyes to see and ears to hear. I am touched by your ministries.'
              )}
            </blockquote>
            <div className="testimonials__dots">
              <button className="testimonials__dot active" data-slide="0"></button>
              <button className="testimonials__dot" data-slide="1"></button>
              <button className="testimonials__dot" data-slide="2"></button>
            </div>
            <cite className="testimonials__author">
              <strong>{__('S. J.')}</strong>
              <br />
              {__('Los Angeles, CA')}
              <br />
              <span className="testimonials__date">
                {__('Subscriber since February 2022')}
              </span>
            </cite>
          </div>

          <div className="testimonials__slide">
            <blockquote className="testimonials__quote">
              {__(
                "That Which Is has been life changing for me. The ability to access so much of the work of J-R and JM and others, at any time, on my phone, is such a treat and privilege. I've been in the Movement for almost 40 years and I have learned more about the Traveler's teachings since I've had TWI than all the years before that. I can't imagine why anyone in MSIA would NOT have TWI. What a gift."
              )}
            </blockquote>
            <div className="testimonials__dots">
              <button className="testimonials__dot" data-slide="0"></button>
              <button className="testimonials__dot" data-slide="1"></button>
              <button className="testimonials__dot" data-slide="2"></button>
            </div>
            <cite className="testimonials__author">
              <strong>{__('R.M.')}</strong>
              <br />
              {__('Hendersonville, NC')}
              <br />
              <span className="testimonials__date">
                {__('Subscriber since July 2020')}
              </span>
            </cite>
          </div>

          <div className="testimonials__slide">
            <blockquote className="testimonials__quote">
              {__(
                'Since I subscribed, I have been listening to the J-R videos several times a day, including material I do not recall hearing before, and have been truly uplifted and inspired. Bless you for this great gift.'
              )}
            </blockquote>
            <div className="testimonials__dots">
              <button className="testimonials__dot" data-slide="0"></button>
              <button className="testimonials__dot" data-slide="1"></button>
              <button className="testimonials__dot" data-slide="2"></button>
            </div>
            <cite className="testimonials__author">
              <strong>{__('S.S.')}</strong>
              <br />
              {__('Palm Springs, CA')}
              <br />
              <span className="testimonials__date">
                {__('Subscriber since June 2022')}
              </span>
            </cite>
          </div>
        </div>
      </div>
    </section>
  );
};

export default GuestTestimonials;